"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const Svg = __importStar(require("react-native-svg"));
exports.default = (props) => (React.createElement(Svg.Svg, Object.assign({}, props, { viewBox: '0 0 24 24' }),
    React.createElement(Svg.G, { "data-name": 'Layer 2' },
        React.createElement(Svg.G, { "data-name": 'smartphone' },
            React.createElement(Svg.Rect, { width: '24', height: '24', transform: 'rotate(90 12 12)', opacity: '0' }),
            React.createElement(Svg.Path, { d: 'M17 2H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3zm-5 16a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 12 18zm2.5-10h-5a1 1 0 0 1 0-2h5a1 1 0 0 1 0 2z' })))));
//# sourceMappingURL=Smartphone.js.map